var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_919_735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.21711 11.8835C7.14191 11.6552 7.06358 11.4206 6.90691 11.2423C6.74084 11.0547 6.50584 10.9483 6.27711 10.8451L2.74585 9.26255C2.05338 8.95292 2.00951 7.98962 2.66751 7.61431C5.97004 5.73774 9.65484 4.56176 13.2926 3.4108L19.3776 1.48733C20.0575 1.27152 20.7186 1.87515 20.562 2.56948C19.5875 6.91685 18.5472 11.2517 17.4412 15.5678C17.3033 16.1026 16.5952 16.5999 16.2129 16.2027C14.9596 14.911 12.3432 13.2659 10.6512 12.4277C10.2596 12.2338 9.88044 16.9283 8.81824 16.5342C8.15084 16.2872 7.44898 12.6028 7.21711 11.8866V11.8835Z",
    stroke: "#DE296E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98242 11.308C9.34809 10.0945 11.2908 8.21793 13.4089 6.61347C15.8967 4.73065 17.1689 4.21146 19.5784 2.23169",
    stroke: "#DE296E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4922 12.728C11.4792 10.7295 13.2088 9.21887 14.8193 7.67383C16.5709 5.99118 18.2252 4.20844 19.7731 2.33813",
    stroke: "#DE296E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77148 15.9025C10.959 15.2364 11.9397 14.5764 12.9612 13.6757C12.2875 13.3942 11.6014 13.2222 10.8744 13.1409C10.8306 13.1346 10.7836 13.1315 10.7428 13.1471C10.699 13.1628 10.6645 13.2003 10.6363 13.241C10.3324 13.6413 10.3292 14.1855 10.2822 14.6859C10.2634 14.9048 10.2321 15.13 10.113 15.3146C9.99082 15.5053 9.79968 15.6742 9.77148 15.8994V15.9025Z",
    fill: "#DE296E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_919_735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon_share.d602128fa109aaf0823c6ab02b99c036.svg";
export { ForwardRef as ReactComponent };